import { PARTNERS } from "@/data/site";

const Row = ({ items, hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {items.map((name, i) => (
      <span key={name} className="flex items-center">
        <span className={`whitespace-nowrap px-8 font-display text-5xl font-extrabold uppercase sm:text-7xl lg:text-8xl ${i % 2 ? "text-transparent [-webkit-text-stroke:1px_#5B6573]" : "text-ink"}`}>
          {name}
        </span>
        <span className="h-3 w-3 rotate-45 border border-brand" />
      </span>
    ))}
  </div>
);

export const PartnerMarquee = ({ items = PARTNERS, label = "Section 04 — Developers & main contractors we work with", testid = "partner-marquee" }) => (
  <section className="border-y border-canvas-line bg-canvas-800 py-14 sm:py-20" data-testid={testid}>
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <p className="label-mono text-brand">{label}</p>
    </div>
    <div className="mt-10 overflow-hidden">
      <div className="flex w-max animate-marquee">
        <Row items={items} />
        <Row items={items} hidden />
      </div>
    </div>
  </section>
);
